import type { SVGProps } from "react";
const SvgRecoil = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 256 256"
    {...props}
  >
    <rect width="100%" height="100%" fill="#fff" />
    <path
      fill="#212121"
      d="M103.367 111.992c1.687-.36 3.42-.615 5.154-.769L122 109.92l-18.307-20.428c-5.509-6.17-8.551-14.157-8.551-22.5H80c0 12.185 4.45 23.885 12.524 32.892zM152.17 142.992c-1.389.25-2.807.425-4.225.575L133 144.949l18.705 19.98c5.643 6.049 8.76 13.882 8.76 22.063H176c0-11.949-4.559-23.393-12.83-32.254z"
    />
    <path
      fill="#212121"
      d="M177.393 97.684c-2.53-12.659-12.396-21.872-25.123-23.49l-2.353-.31c-7.95-1.006-13.956-7.85-13.956-15.903v-8.26a19.63 19.63 0 0 0 12.012-18.116C147.978 20.773 139.264 12 128.505 12s-19.473 8.773-19.473 19.605a19.64 19.64 0 0 0 11.551 17.908v8.464c0 15.873 11.782 29.334 27.424 31.287l2.352.31c7.336.927 10.99 6.38 11.959 11.165.97 4.785-.283 11.243-6.697 14.974-3.145 1.827-6.544 2.934-10.145 3.268l-35.345 3.344a40.25 40.25 0 0 0-16.41 5.274c-11.118 6.482-16.664 18.836-14.105 31.495 2.53 12.659 12.397 21.872 25.124 23.491l2.352.309c7.951 1.006 13.957 7.85 13.957 15.903v7.511c-7.029 2.958-11.959 9.957-11.959 18.087 0 10.832 8.713 19.605 19.473 19.605s19.472-8.773 19.472-19.605a19.61 19.61 0 0 0-11.604-17.932v-7.666c0-15.874-11.781-29.335-27.423-31.288l-2.352-.309c-7.336-.928-10.99-6.38-11.96-11.165-.97-4.786.284-11.243 6.698-14.975 3.144-1.827 6.543-2.934 10.144-3.267l35.345-3.345a40.24 40.24 0 0 0 16.41-5.273c11.114-6.482 16.631-18.832 14.1-31.49"
    />
  </svg>
);
export default SvgRecoil;
